import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { AppraisalStore } from "../stores/appraisalStore";

export const useAppraisalStore = () => useContext<{
  appraisalStore: AppraisalStore;
}>(StoreContext);